// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main__2S5BO","Main_header":"Main_header__2S5BO","Main_header___noPadding":"Main_header___noPadding__2S5BO","Main_article":"Main_article__2S5BO"};